function parseThresholdNumber(value) {
  if (value == null || typeof value === "boolean") return null;

  if (typeof value === "string" && value.trim() === "") {
    return null;
  }

  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
}

export function getSignedThresholdStatus(currentValue, targetValue) {
  const current = parseThresholdNumber(currentValue);
  const target = parseThresholdNumber(targetValue);

  if (current == null || target == null) {
    return null;
  }

  const reached = target >= 0 ? current >= target : current <= target;

  return {
    current,
    target,
    reached,
    distance: Math.abs(target - current),
  };
}
